import React, { Fragment, useMemo } from 'react';
import { ReactComponent as BasketIcon } from 'assets/icons/basket.svg';
import { ReactComponent as DotIcon } from 'assets/icons/dot-icon.svg';
import { ReactComponent as LineIcon } from 'assets/icons/line.svg';
import { formatCurrency } from 'utils/functions';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import { ENUM_ORDERS_TYPE } from 'utils/enum';
import useDashboardContext from 'contexts/dashboard.context';
import './styles.scss';

const HeaderBasket = () => {
  const { isBasketDisabled, basketValue } = useDashboardContext();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const type = useMemo(() => {
    const isGroup = pathname === ROUTE_KEYS.GROUP_BASKET;
    const isBulk = pathname === ROUTE_KEYS.BULK_BASKET;
    const isBatch = pathname === ROUTE_KEYS.BATCH_BASKET;
    if (isGroup) return ENUM_ORDERS_TYPE.GROUP;
    if (isBulk) return ENUM_ORDERS_TYPE.BULK;
    if (isBatch) return ENUM_ORDERS_TYPE.BATCH;
    return (searchParams.get('type') as ENUM_ORDERS_TYPE) ?? '';
  }, [pathname]);

  return (
    <Fragment>
      {!isBasketDisabled ? (
        <Link className='flex items-center gap-4' to={`/orders/basket/${type}`}>
          <div className='flex items-center py-[8.5px] px-[14px] bg-[#F2F2F3] rounded-full cursor-pointer'>
            <BasketIcon className='mr-[6px]' />
            <span className='font-medium text-sm text-[#2E3031] capitalize'>{type} Basket</span>
            {basketValue ? (
              <div className='flex items-center'>
                <DotIcon className='mx-[4px]' />
                <span className='font-medium text-sm text-[#2E3031]'>
                  {formatCurrency(basketValue)}
                </span>
              </div>
            ) : null}
          </div>
          <LineIcon />
        </Link>
      ) : (
        <div className='flex items-center gap-4 header-basket'>
          <div className='flex items-center py-[8.5px] px-[14px] text-gray-4 bg-[#F2F2F3] cursor-not-allowed rounded-full'>
            <BasketIcon className='mr-[6px] text-gray-5 basket' />
            <span className='font-medium text-sm capitalize text-gray-4'>{type} Basket</span>
          </div>
          <LineIcon />
        </div>
      )}
    </Fragment>
  );
};

export default HeaderBasket;
